export interface GuideItem {
  icon: string;
  title: string;
  content: string;
}

export const guideItems: GuideItem[] = [
  {
    icon: 'ri-shield-star-line',
    title: '分级提示',
    content:
      '本片在香港被列为第三级影片，含有成人内容，仅适合成年观众观看。请确认自身年龄并了解当地分级规定后再决定是否观看。',
  },
  {
    icon: 'ri-history-line',
    title: '时代背景',
    content:
      '1990 年代是香港电影工业的繁荣期，类型片百花齐放。「蜜桃」系列正是在这样的市场环境下诞生，也记录下港片黄金时代的一种产业生态。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '观影重点',
    content:
      '建议关注女主角的完整成长弧线：从叛逆出走、遭遇背叛，到旅途中的险境与相遇，再到最终的和解。这条线索是本片区别于一般同类作品的关键。',
  },
  {
    icon: 'ri-disc-line',
    title: '版本提示',
    content:
      '不同发行渠道的版本在剪辑、画质与字幕上可能有所不同，观看前可留意发行信息，并优先选择正规、合法的观看渠道。',
  },
  {
    icon: 'ri-play-list-line',
    title: '延伸观看顺序',
    content:
      '建议先看 1993 年的原版打底，再了解 1997 年的续作与 2011 年的新篇，对比系列在题材、风格与时代语境上的演变，会更有意思。',
  },
];